import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "grades",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-setup" */ "GradesSetup/components"),
      import(
        /* webpackChunkName: "grade-setup" */ "GradesSetup/modules/GradesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "gradesSetup",
        reducer,
      });
      return component;
    })
  ),
});
